export interface IProfessionalByGenreWithStatus {
  genre: string;
  status: boolean;
  count: string;
}

export interface IProfessionalByLocationWithStatus {
  address_country: string;
  status: boolean;
  count: string;
}

export interface IProfessionalByAccessControl {
  access_control: boolean;
  count: string;
}

export interface IAnnualProfessionalByStatusWithMonth {
  month: string;
  year: string;
  active_number: number;
  inactive_number: number;
}

export interface IAnnualProfessionalByStatusWithAge {
  status: boolean;
  age: number;
  count: string;
}

export interface IAnnualProfessionalByPaymentStatusWithMonth {
  month: number;
  payment_status: string;
  count: string;
  year: string;
}

export interface IHistoricAnnualProfessionalByStatus {
  year: number;
  active_number: string;
  inactive_number: string;
  // status: boolean;
  // count: number;
}

export interface IProfessionalByStateWithStatus {
  address_state: string;
  status: boolean;
  count: string;
}

export interface IProfessionalsData {
  professionalByGenreWithStatus: IProfessionalByGenreWithStatus[];
  professionalByLocationWithStatus: IProfessionalByLocationWithStatus[];
  professionalByAccessControl: IProfessionalByAccessControl[];
  annualProfessionalByStatusWithMonth: IAnnualProfessionalByStatusWithMonth[];
  annualProfessionalByStatusWithAge: IAnnualProfessionalByStatusWithAge[];
  annualProfessionalByPaymentStatusWithMonth: IAnnualProfessionalByPaymentStatusWithMonth[];
  historicAnnualProfessionalByStatus: IHistoricAnnualProfessionalByStatus[];
  professionalByStateWithStatus: IProfessionalByStateWithStatus[];
}

export interface IStudentsData {
  annualStudentByStatusWithAge: {
    status: boolean;
    age: number;
    count: string;
  }[];
  annualStudentByStatusWithMonth: {
    month: number;
    status: boolean;
    count: string;
  }[];
  historicAnnualStudentByStatus: {
    status: boolean;
    year: number;
    count: number;
  }[];
  studentByGenreWithStatus: {
    genre: string;
    status: boolean;
    count: string;
  }[];
  studentByLocationWithStatus: {
    address_country: string;
    status: boolean;
    count: string;
  }[];
  studentByStateWithStatus: {
    address_state: string;
    status: boolean;
    count: string;
  }[];
}

export enum FinancesDataType {
  SUBSCRIPTIONS_BY_STATUS = 'countAndSumSubscriptionsByStatus',
  SUBSCRIPTIONS_BY_PLAN_NAME = 'countAndSumSubscriptionsByPlanName',
  SUBSCRIPTIONS_BY_PAYMENT_METHOD = 'countAndSumSubscriptionsByPaymentMethod',
  PAYMENTS_BY_MONTH_AND_YEAR = 'countAndSumPaymentsByMonthAndYear',
}

export interface IFinancesData {
  countAndSumSubscriptionsByStatus: IVindiPaymentStatusData[];
  countAndSumSubscriptionsByPlanName: IVindiReportsFinancesData[];
  countAndSumSubscriptionsByPaymentMethod: IVindiPaymentMethodsData[];
  countAndSumPaymentsByMonthAndYear: IVindiPaymentByMonthAndYearData[];
}

export interface IVindiBillItemData {
  id: number;
  amount: string;
  quantity: number;
  pricing_range_id: null | string | number;
  description: string | null;
  pricing_schema: {
    id: number;
    short_format: string;
    price: string;
    minimum_price: null | string | number;
    schema_type: string;
    pricing_ranges: unknown[];
    created_at: string;
  };
}

export interface IVindiChargesData {
  id: number;
  amount: string;
  status: string;
  due_at: string;
  paid_at: null | unknown;
  installments: number;
  attempt_count: number;
  next_attempt: null | unknown;
  print_url: null | string;
  created_at: string;
  updated_at: string;
  last_transaction: string;
  payment_method: {
    id: number;
    public_name: string;
    name: string;
    code: string;
    type: string;
  };
}

export interface IVindiCustomerData {
  id: number;
  name: string;
  email: string;
  code: string;
}

export interface IVindiPeriodData {
  id: number;
  billing_at: string;
  cycle: number;
  start_at: string;
  end_at: string;
  duration: number;
}

export interface IVindiSubscriptionPlanData {
  id: number;
  name: string;
  code: null | unknown;
}

export interface IVindiSubscriptionData {
  id: number;
  code: null | unknown;
  plan: IVindiSubscriptionPlanData;
  customer: IVindiCustomerData;
}

export interface IVindiPaymentStatusData {
  total: string;
  paymentStatus: string;
  quantity: number;
  count: string;
}

export interface IVindiReportsFinancesData {
  total: string;
  planName: string;
  quantity: number;
  count: string;
}

export interface IVindiPaymentMethodsData {
  total: string;
  paymentMethod: string;
  quantity: number;
  count: string;
}

export interface IVindiPaymentByMonthAndYearData {
  total: string;
  month: string;
  quantity: number;
  count: string;
}

export interface IVindiFinancesData {
  bills: {
    id: number;
    code: null | string;
    amount: string;
    installments: number;
    status: string;
    seen_at: null | string;
    billing_at: null | string;
    due_at: string;
    url: string;
    created_at: string;
    updated_at: string;
    bill_items: IVindiBillItemData[];
    charges: IVindiChargesData[];
    bill_affiliates: unknown[];
    customer: IVindiCustomerData;
    period: IVindiPeriodData;
    subscription: IVindiSubscriptionData;
    metadat: unknown;
    payment_profile: null | unknown;
    payment_condition: null | unknown;
  }[];
}
